/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_ALL_CARTS = gql`
  query GetAllCarts {
    getAllCarts {
      _id
      totalAmount

      items {
        costumeValue {
          id
          name
          topupPrice
          minDownPayment
        }
        costumeAttribute {
          id
        }
        costumeFeature {
          id
        }
        costumeType {
          id
        }
      }
      presentation {
        id
      }
      section {
        id
        name
        costumeTypes {
          name
        }
      }
      availableTime
      address {
        addressLine1
        city
      }
      referal
      delivery {
        isOpted
      }
    }
  }
`;
